const SIZES = {
  xs: '576px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
} as const

export const BREAKPOINTS = {
  xs: `(max-width: ${SIZES.xs})`,
  sm: `(min-width: ${SIZES.sm})`,
  md: `(min-width: ${SIZES.md})`,
  lg: `(min-width: ${SIZES.lg})`,
  xl: `(min-width: ${SIZES.xl})`,
  xxl: `(min-width: ${SIZES.xxl})`,
} as const
